export default {
    SOLICITADO: 1,
    DEVOLVIDO: 2,
    REENVIADA: 3,
    CANCELADO: 4,
    EM_ESPERA: 5,
    AGENDADO: 6,
    REAGENDADO: 7,
    FALTA: 8,
    REALIZADO: 9,
    REMARCAR: 10,
}